import react from 'react';
import '../cssfiles/Home.css';
import trailerVideo from '../Images/Timeline 1.mp4';
import webImg from '../Images/ebsite image.png';
import profilepic from '../Images/profile pic].png'
import { TypeAnimation } from 'react-type-animation';
import About from './about';


function Home(){
    return (
        <>
            <div className="Home">
           <video 
              src={trailerVideo} 
              autoPlay 
              loop 
              muted 
              playsInline 
              style={{ width: "100%", height: "auto"  }} 
          />

            <TypeAnimation className='Description'
       sequence={[
        // Same substring at the start will only be typed out once, initially
        "My goal is to bring smiles to people's faces.",
        3000, // wait 1s before replacing "Mice" with "Hamsters"
        "My ambition is to develop the best game in the market.",
        3000,
        'I’m putting in my best effort to create a best fun game. ',
        3000
        ]}
        wrapper="P" 
        speed={50}
        repeat={Infinity}
       />




            <p className='hardworking'>I have developed five well-crafted games, putting my heart and effort into creating enjoyable experiences for players.</p>
            
            <div className='FounderInfo'> 
            <img src={webImg} border="0" className='aestheticimg'/>
               <div className='MyProfile'>
                   <img className='profilepic' src={profilepic} />
                    <p className='Name'>Founder: Samim Ahmed</p>
                     
                     <p className='ProfAbout'>Hi, I’m Samim Ahmed, a self-taught game developer with a passion for creating fun and engaging experiences. With nearly two years of experience in programming and game development, I strive to bring joy to people through my games. Every project I work on is driven by my love for game development, and nothing makes me happier than seeing players enjoy what I create.</p>
                    
               </div>
            </div>

           
            </div>
            <About />
            <p className='SocialMediaTxt'>Follow my journey on social media.</p>
            <div className='SocialMedia'>
                <a className='instagram'  href='https://www.instagram.com/mukstargame?igsh=bjV2ZXZrcjJzZGNh'> <i class="fa-brands fa-instagram"></i></a>
                <a className='youtube'  href='https://youtube.com/@oxomgamedev?si=ELzs1hx4NHhblZ-E'><i class="fa-brands fa-youtube"></i></a>
                <a className='instagramtwo'  href='https://www.instagram.com/somim_muktar?igsh=NTY2dTV5dTRpeGZl'> <i class="fa-brands fa-instagram"></i></a>
             </div>
             
            
        </>
    )
}
export default Home;